import React from 'react';

export const HalalIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9039 21.5C26.4039 20.8333 28.0039 19.9 30.4039 21.5C30.9039 21.8333 32.2039 22.5 33.4039 22.5C32.2372 22.6667 29.7039 23.1 28.9039 23.5C27.9039 24 22.9039 26 23.4039 19.5V14.5C23.2372 18 21.5 26.5 15.4039 25.5M12.9039 16C12.5039 12.4 13.0706 11.5 13.4039 11.5C13.2372 12.1667 13.7 13.5 14.5 13.5C14.1026 13.5 13.227 14 12.9039 16ZM12.9039 16C13.4039 20.5 14.4039 22.5 12.9039 24C11.4039 25.5 4.4039 25.5 6.4039 20.5M16.4039 16.5V14.5C17.2372 15.1667 19.0039 17.1 19.4039 19.5C18.9691 18 18 17 16.4039 16.5ZM38 19.5C38 29.7173 29.7173 38 19.5 38C9.28273 38 1 29.7173 1 19.5C1 9.28273 9.28273 1 19.5 1C29.7173 1 38 9.28273 38 19.5Z"
      stroke="url(#paint0_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.47176"
        y1="27.1477"
        x2="40.2332"
        y2="17.8833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
